import { Pet } from './../../../auth/_models/pet';
import { PetsService } from 'src/app/auth/_services/pets.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-my-pet-data',
  templateUrl: './my-pet-data.component.html',
  styleUrls: ['./my-pet-data.component.css']
})
export class MyPetDataComponent implements OnInit {

  pet: Pet = new Pet({});

  constructor(
    private _route: ActivatedRoute,
    private _service: PetsService,
  ) { }

  ngOnInit() {

    this._route.parent.params.subscribe(params => {
      const uuid = params['id'];
      this._service
        .getPet(uuid)
        .valueChanges()
        .subscribe(p => {

          p.uuid = uuid;

          if (p.birthday) {
            if (typeof p.birthday.toDate === 'function') {
              p.birthday = p.birthday.toDate();
            }
          }

          this.pet = p;
          console.log(this.pet);
        });
    });

  }

}
